'use strict';

/**
 *  Load modules
 */
import echo from './modules/echo.js';
import '../scss/app.scss';
import autosize from 'autosize/dist/autosize.min';
$(document).ready(function () {
  $('.values__right-slider').slick({
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500
  });
  $('.values__right-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.values__right-slide').eq(currentSlide).children('.values__right-slide-info').removeClass('values__right-slide-info_active');
    $('.values__right-slide').eq(nextSlide).children('.values__right-slide-info').addClass('values__right-slide-info_active');
    $('.values__right-slider .slick-dots').css('top', $('.values__right-slider .values__right-slide').eq(nextSlide).children('.values__right-slide-img').height() + 20 + 'px');
  });
  $('.values__right-slider .slick-dots').css('top', $('.values__right-slider .values__right-slide.slick-current').children('.values__right-slide-img').height() + 20 + 'px');
  $(window).on('resize', function () {
    $('.values__right-slider .slick-dots').css('top', $('.values__right-slider .values__right-slide.slick-current').children('.values__right-slide-img').height() + 20 + 'px');
  });
  $('.values__left-slider').slick({
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500
  });
  $('.values__left-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.values__left-slider .values__left-slide').eq(currentSlide).children('.values__left-slide-info').removeClass('values__left-slide-info_active');
    $('.values__left-slider .values__left-slide').eq(nextSlide).children('.values__left-slide-info').addClass('values__left-slide-info_active');
    $('.values__left-slider .slick-dots').css('top', $('.values__left-slider .values__left-slide').eq(nextSlide).children('.values__left-slide-img').height() + 20 + 'px');
  });
  $('.values__left-slider .slick-dots').css('top', $('.values__left-slider .values__left-slide.slick-current').children('.values__left-slide-img').height() + 20 + 'px');
  $(window).on('resize', function () {
    $('.values__left-slider .slick-dots').css('top', $('.values__left-slider .values__left-slide.slick-current').children('.values__left-slide-img').height() + 20 + 'px');
  });
  /*Values left right copy*/

  $('.values__left-slider_copy').slick({
    arrows: false,
    dots: true,
    fade: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500
  });
  $('.values__left-slider_copy').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.values__left-slider_copy').eq(currentSlide).children('.values__left-slide-info').removeClass('values__left-slide-info_active');
    $('.values__left-slider_copy .values__left-slide').eq(nextSlide).children('.values__left-slide-info').addClass('values__left-slide-info_active');
    $('.values__left-slider_copy .slick-dots').css('top', $('.values__left-slider_copy .values__left-slide').eq(nextSlide).children('.values__left-slide-img').height() + 20 + 'px');
  });
  $('.values__left-slider_copy .slick-dots').css('top', $('.values__left-slider_copy .values__left-slide.slick-current').children('.values__left-slide-img').height() + 20 + 'px');
  $(window).on('resize', function () {
    $('.values__left-slider_copy .slick-dots').css('top', $('.values__left-slider_copy .values__left-slide.slick-current').children('.values__left-slide-img').height() + 20 + 'px');
  });

  /* Show/hide workers */
  $(window).on('load', function () {
    var teamWorkersActive = $('.team__worker_active');
    if ($(window).width() < 768 && teamWorkersActive.length == 8) {
      for (var i = 0; i < teamWorkersActive.length; i++) {
        if (i > 3) {
          $(teamWorkersActive).eq(i).removeClass('team__worker_active');
        }
      }
    }
  });
  $('.team__photos-more-btn-link').click(function (e) {
    e.preventDefault();
    var workersCount = $('.team__photos-grid').children('.team__worker').length;
    var activeWorkers = $('.team__photos-grid').children('.team__worker_active').length;
    var lastActiveWorker = $('.team__photos-grid').children('.team__worker_active:last').index();
    var showMore = 8;
    if ($(window).width() < 768) {
      showMore = 4;
    }
    if (workersCount < activeWorkers + showMore) {
      showMore = workersCount - activeWorkers;
    }
    for (var i = 1; i <= showMore; i++) {
      var teamWorker = $('.team__photos-grid').children('.team__worker').eq(i + lastActiveWorker);
      teamWorker.addClass('team__worker_active');
    }
    var activeWorkersAfterClick = $('.team__photos-grid').children('.team__worker_active').length;
    if (workersCount == activeWorkersAfterClick) {
      $('.team__photos-more-btn-link').css('display', 'none');
      $('.team__photos-less-btn-link').css('display', 'inline-block');
    }
  });
  $('.team__photos-less-btn-link').click(function (e) {
    e.preventDefault();
    var workerMinCount = 8;
    if ($(window).width() < 768) {
      workerMinCount = 4;
    }
    var workersCount = $('.team__photos-grid').children('.team__worker').length;
    $('.team__photos-grid').children('.team__worker').removeClass('team__worker_active');
    if (workersCount < workerMinCount) {
      workerMinCount = workersCount;
    }
    for (var i = 0; i < workerMinCount; i++) {
      $('.team__photos-grid').children('.team__worker').eq(i).addClass('team__worker_active');
    }
    $(this).css('display', 'none');
    $('.team__photos-more-btn-link').css('display', 'inline-block');
  });
  $('.services__accordion-item-title').click(function () {
    if ($(this).parent('.services__accordion-item').hasClass('services__accordion-item_active')) {
      $(this).parent('.services__accordion-item').removeClass('services__accordion-item_active');
      $(this).siblings('.services__accordion-item-content').slideUp(500);
      $(this).children('.services__accordion-item-title-img').css('display', 'block');
      $(this).children('.services__accordion-item-title-img_opened').css('display', 'none');
    } else {
      $(this).parent('.services__accordion-item').addClass('services__accordion-item_active');
      /* + */
      $(this).parent('.services__accordion-item').siblings('.services__accordion-item').removeClass('services__accordion-item_active');
      $(this).children('.services__accordion-item-title-img').css('display', 'none');
      /* + */
      $(this).parent('.services__accordion-item').siblings('.services__accordion-item').children('.services__accordion-item-title').children('.services__accordion-item-title-img').css('display', 'block');
      $(this).siblings('.services__accordion-item-content').slideDown(500);
      /* + */
      $(this).parent('.services__accordion-item').siblings('.services__accordion-item').children('.services__accordion-item-content').slideUp(500);
      $(this).children('.services__accordion-item-title-img_opened').css('display', 'block');
      $(this).parent('.services__accordion-item').siblings('.services__accordion-item').children('.services__accordion-item-title').children('.services__accordion-item-title-img_opened').css('display', 'none');
    }
  });
  $('.projects__slides').slick({
    accessibility: false,
    arrows: true,
    appendArrows: $('.projects__arrows'),
    dots: true,
    draggable: false,
    fade: true,
    infinite: false,
    appendDots: $('.projects__slide-description')
  });
  $('.projects__slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.projects__slide').eq(nextSlide).children('.projects__slide-description').children('.slick-dots').children('li').eq(nextSlide).addClass('slick-active-dot');
  });
  $('.projects__arrows > .slick-arrow').html('');
  $('.projects__category-btn').click(function () {
    $('.projects__category-btn').removeClass('projects__category-btn_active');
    $(this).addClass('projects__category-btn_active');
    $('.projects__all-btn_mobile').text($(this).text());
  });
  $('.projects__categories-list>ul>li').click(function () {
    $('.projects__all-btn_mobile').text($(this).text());
    $('.projects__category-btn').removeClass('projects__category-btn_active');
    $('.projects__category-btn').eq($(this).index()).addClass('projects__category-btn_active');
    $('.projects__categories-list').slideUp(500).removeClass('projects__categories-list_active');
    $('.projects__categories_current').removeClass('projects__categories_current_active');
  });
  $('.projects__category-btn, .projects__categories-list>ul>li').click(function () {
    var current_filter = $(this).data('filter');
    $('.projects__slides').slick('slickUnfilter');
    if (current_filter == 'all') {
      $('.projects__slides').slick('slickUnfilter');
    } else {
      $('.projects__slides').slick('slickFilter', '.' + current_filter);
    }
    $('.projects__arrows > .slick-arrow').html('');
  });
  $('.projects__categories_current').click(function () {
    if ($('.projects__categories-list').hasClass('projects__categories-list_active')) {
      $('.projects__categories-list').slideUp(500).removeClass('projects__categories-list_active');
      $(this).removeClass('projects__categories_current_active');
    } else {
      $('.projects__categories-list').slideDown(500).addClass('projects__categories-list_active');
      $(this).addClass('projects__categories_current_active');
    }
  });
  $('.projects__slider').hide();
  $('.projects__slider_all').show();
  $('.main-form__column label .wpcf7-form-control-wrap input, .main-form__column label .wpcf7-form-control-wrap textarea').focus(function () {
    if ($(window).width() > 768) {
      $(this).parent('.wpcf7-form-control-wrap').prev('.label__text').css({
        top: '-10px',
        'font-size': '14px'
      }).addClass('label__text_active');
    } else {
      $(this).parent('.wpcf7-form-control-wrap').prev('.label__text').css({
        top: '-20px',
        'font-size': '10px'
      }).addClass('label__text_active');
    }
  });
  $('' + '.main-form__column label .wpcf7-form-control-wrap input, ' + '.main-form__column label .wpcf7-form-control-wrap textarea').blur(function () {
    if ($(this).val() == '') {
      $(this).parent('.wpcf7-form-control-wrap').prev('.label__text').removeAttr('style').removeClass('label__text_active');
    } else {
      return;
    }
  });
  $('.label__text').click(function (e) {
    if ($(this).hasClass('label__text_active')) {
      e.preventDefault();
      return;
    } else {
      $(this).addClass('label__text_active');
      $(this).siblings('.wpcf7-form-control-wrap').eq(0).children('input, textarea').focus();
    }
  });
  $('input[type="checkbox"]').on('change', function () {
    if ($(this).parent('.wpcf7-list-item').hasClass('wpcf7-list-item_active')) {
      $(this).parent('.wpcf7-list-item').removeClass('wpcf7-list-item_active');
    } else {
      $(this).parent('.wpcf7-list-item').addClass('wpcf7-list-item_active');
    }
  });
  $('.menu-burger').click(function () {
    if ($('.header__topbar-wrapper').hasClass('header__topbar-wrapper_active')) {
      $('.header__topbar-wrapper').removeClass('header__topbar-wrapper_active');
    } else {
      $('.header__topbar-wrapper').addClass('header__topbar-wrapper_active');
    }
  });
  document.addEventListener('wpcf7mailsent', function (event) {
    $('.main-form__submit input').attr('value', 'gesendet');
    $('.main-form__submit input').css('color', 'white');
    $('.main-form__submit_job input').css('color', 'black');
    $('.main-form__submit input').css('background-color', 'black');
    $('.main-form__submit_job input').css('background-color', 'white');
    $('.main-form__submit input').css('border-color', 'black');
    $('.main-form__submit_job input').css('border-color', 'white');
    $('.wpcf7-response-output').css('display', 'none');
    //$('.main-form__submit-label').addClass('main-form__submit-label_success');
    setTimeout(function () {
      $('.main-form__submit input').attr('value', 'senden');
      $('.main-form__submit input').removeAttr('style');
      //$('.main-form__submit-label').removeAttr('style');
      //$('.main-form__submit-label').removeClass('main-form__submit-label_success');
    }, 2000);
  }, false);
  if ($('.main-form__submit input').attr('value') == 'gesendet') {
    $('.main-form__submit input').click(function (e) {
      e.preventDefault();
    });
  }
  ;
  $('.nachricht-txt').attr('rows', 1);
  autosize($('textarea'));
  var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 900
  });
  $(".values__right-slide-img").on("click", function () {
    $('.values__right-slider').slick("slickNext");
  });
  $(".values__left-slider .values__left-slide-img").on("click", function () {
    $('.values__left-slider').slick("slickNext");
  });
  $(".values__left-slider_copy .values__left-slide-img").on("click", function () {
    $('.values__left-slider_copy').slick("slickNext");
  });
  $('.mobile-nav ul li a').click(function () {
    $('.header__topbar-wrapper').removeClass('header__topbar-wrapper_active');
  });
  $(window).on('scroll resize load', function () {
    if ($(this).scrollTop() > 50 && $(window).width() < 768) {
      $('.to-top').css('opacity', 1);
    } else if ($(this).scrollTop() < 50 || $(window).width() > 768) {
      $('.to-top').css('opacity', 0);
    }
  });
  $('.to-top').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 1000);
    return false;
  });
  jQuery(window).scroll(function () {
    var sections = $('section');
    sections.each(function (i, el) {
      var top = $(el).offset().top - 100;
      var bottom = top + $(el).height();
      var scroll = $(window).scrollTop();
      var sectionClassName = $(el).attr('class');
      if (scroll > top && scroll < bottom) {
        $('.main-nav__list li a.active').removeClass('active');
        $('.mobile-nav__list li a.active').removeClass('active');
        $('a[href="/#' + sectionClassName + '"]').addClass('active');
      }
      if (scroll < 100) {
        $('.main-nav__list li a.active').removeClass('active');
        $('.mobile-nav__list li a.active').removeClass('active');
      }
    });
  });
  $('.jobs-filters__filters-criteria').hover(function () {
    $(this).children('.jobs-filters__filters-criteria-list-wrapper').addClass('jobs-filters__filters-criteria-list-wrapper_visible');
  }, function () {
    $(this).children('.jobs-filters__filters-criteria-list-wrapper').removeClass('jobs-filters__filters-criteria-list-wrapper_visible');
  });

  /*Jobs filtering*/

  /*let jobLocations = [];
  let jobDepartments = [];
  let jobPositions = [];
   function prepareFilters(updateFilters = false){
      let jobs = $('.jobs-filters__job');
      if ( updateFilters ) {
          jobs = $('.jobs-filters__job_visible');
          jobLocations = [];
          jobDepartments = [];
          jobPositions = [];
      }
      jobs.each(function (ind, el) {
          if ( $(el).data('location') != undefined ) {
              jobLocations.push($(el).data('location').trim());
          }
          if ( $(el).data('department') != undefined ) {
              jobDepartments.push($(el).data('department').trim());
          }
          if ( $(el).data('position') != undefined ) {
              jobPositions.push($(el).data('position').trim());
          }
      });
  }
   function fillFilter(enterArr, elTofill,) {
      $(elTofill).children('.jobs-filters__filters-criteria-list-wrapper').children('.jobs-filters__filters-criteria-list').empty();
      let jList = enterArr.filter((e, i, self) => i === self.indexOf(e)).sort();
      $.each(jList, function (i, elVal) {
          $(elTofill).children('.jobs-filters__filters-criteria-list-wrapper').children('.jobs-filters__filters-criteria-list').append('<li>' + elVal + '</li>');
      });
  }
   prepareFilters();
  fillFilter(jobPositions, '.jobs-filters__filters-criteria_position');
  fillFilter(jobDepartments, '.jobs-filters__filters-criteria_department');
  fillFilter(jobLocations, '.jobs-filters__filters-criteria_location');
   $(document).on('click', '.jobs-filters__filters-criteria-list li',  function () {
      let criteriaText = $(this).text();
      $(this)
          .parents('.jobs-filters__filters-criteria-list')
          .parents('.jobs-filters__filters-criteria-list-wrapper')
          .siblings('.jobs-filters__filters-criteria-text')
          .text(criteriaText);
      $(this).siblings('li').removeClass('selected-filter');
      $(this).addClass('selected-filter');
      $('.more-jobs').css('display', 'none');
      let selectedFilter = $(this).text().trim();
      let filterCat = $(this).parents('.jobs-filters__filters-criteria-list-wrapper').parents('.jobs-filters__filters-criteria')[0].classList[1].lastIndexOf('_') + 1;
      let filterCatName = $(this).parents('.jobs-filters__filters-criteria-list-wrapper').parents('.jobs-filters__filters-criteria')[0].classList[1].slice(filterCat).trim();
      if ( $('.jobs-filters__filters').hasClass('jobs-filters__filters_updated') ) {
          $('.jobs-filters__job_visible').each(function (ind, el) {
              if( $(el).data(filterCatName) == selectedFilter ) {
                  $(el).addClass('jobs-filters__job_visible');
              }else {
                  $(el).removeClass('jobs-filters__job_visible');
              }
          });
      }else {
          $('.jobs-filters__filters').addClass('jobs-filters__filters_updated');
          $('.jobs-filters__job').removeClass('jobs-filters__job_visible');
          $('.jobs-filters__job').each(function (ind, el) {
              if( $(el).data(filterCatName) == selectedFilter ) {
                  $(el).addClass('jobs-filters__job_visible');
              }
          });
      }
       prepareFilters(true);
      fillFilter(jobPositions, '.jobs-filters__filters-criteria_position');
      fillFilter(jobDepartments, '.jobs-filters__filters-criteria_department');
      fillFilter(jobLocations, '.jobs-filters__filters-criteria_location');
    });*/

  /*$('.more-jobs').on('click', function (e) {
      e.preventDefault();
      $(".jobs-filters__job:not(.jobs-filters__job_visible):lt(3)").addClass('jobs-filters__job_visible');
      if ( $(".jobs-filters__job:not(.jobs-filters__job_visible)").length == 0 ) {
          $(this).css('display', 'none');
      }
  })*/

  /*
      const $filters = {
          position: $('#filter-position'),
          department: $('#filter-department'),
          location: $('#filter-location')
      };
  
      const $clearButtons = {
          position: $('.clear-btn[data-target="filter-position"]'),
          department: $('.clear-btn[data-target="filter-department"]'),
          location: $('.clear-btn[data-target="filter-location"]')
      };
  
      const $jobItems = $('.job-item');
  
      // Function to get unique values for a given attribute from visible job items
      function getUniqueValues(attribute) {
          const values = new Set();
          $jobItems.filter(':visible').each(function () {
              values.add($(this).data(attribute));
          });
          return Array.from(values).sort();
      }
  
      // Function to update dropdown options based on visible job items
      function updateDropdownOptions() {
          ['position', 'department', 'location'].forEach(function (key) {
              const $select = $filters[key];
              const currentValue = $select.val();
              const options = getUniqueValues(key);
  
              $select.empty();
              $select.append(`<option value="">All ${capitalizeFirstLetter(key)}s</option>`);
              options.forEach(function (option) {
                  $select.append(`<option value="${option}">${option}</option>`);
              });
  
              // Restore previous selection if still available
              if (options.includes(currentValue)) {
                  $select.val(currentValue);
              } else {
                  $select.val('');
              }
  
              // Show or hide clear button
              toggleClearButton(key);
          });
      }
  
      // Function to capitalize the first letter
      function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
      }
  
      // Function to toggle clear button visibility
      function toggleClearButton(key) {
          if ($filters[key].val()) {
              $clearButtons[key].show();
          } else {
              $clearButtons[key].hide();
          }
      }
  
      // Function to filter job items based on selected filters
      function filterJobItems() {
          const selectedFilters = {
              position: $filters.position.val(),
              department: $filters.department.val(),
              location: $filters.location.val()
          };
  
          $jobItems.each(function () {
              const $item = $(this);
              const matches = Object.keys(selectedFilters).every(function (key) {
                  return !selectedFilters[key] || $item.data(key) === selectedFilters[key];
              });
              $item.toggle(matches);
          });
  
          updateDropdownOptions();
      }
  
      // Event listeners for dropdown changes
      Object.keys($filters).forEach(function (key) {
          $filters[key].on('change', function () {
              filterJobItems();
          });
      });
  
      // Event listeners for clear buttons
      Object.keys($clearButtons).forEach(function (key) {
          $clearButtons[key].on('click', function () {
              $filters[key].val('');
              filterJobItems();
          });
      });
  
      // Initial population of dropdowns
      function initializeDropdowns() {
          ['position', 'department', 'location'].forEach(function (key) {
              const $select = $filters[key];
              const options = new Set();
              $jobItems.each(function () {
                  options.add($(this).data(key));
              });
  
              $select.empty();
              $select.append(`<option value="">All ${capitalizeFirstLetter(key)}s</option>`);
              Array.from(options).sort().forEach(function (option) {
                  $select.append(`<option value="${option}">${option}</option>`);
              });
  
              toggleClearButton(key);
          });
      }
  
      // Initialize filters on page load
      initializeDropdowns();
  
      const itemsPerPage = 3;
      let currentVisibleCount = 0;
  
  // Function to manage how many items are visible
      function updateJobPagination() {
          const $visibleJobs = $('.job-item:visible');
          const totalVisible = $visibleJobs.length;
  
          $visibleJobs.hide(); // Hide all first
          currentVisibleCount = Math.min(currentVisibleCount || itemsPerPage, totalVisible);
          $visibleJobs.slice(0, currentVisibleCount).show();
  
          // Show or hide the "Show More" button
          if (currentVisibleCount < totalVisible) {
              $('#load-more-btn').show();
          } else {
              $('#load-more-btn').hide();
          }
      }
  
  // Re-call pagination after filtering
      function filterJobItems() {
          const selectedFilters = {
              position: $filters.position.val(),
              department: $filters.department.val(),
              location: $filters.location.val()
          };
  
          $jobItems.each(function () {
              const $item = $(this);
              const matches = Object.keys(selectedFilters).every(function (key) {
                  return !selectedFilters[key] || $item.data(key) === selectedFilters[key];
              });
              $item.toggle(matches);
          });
  
          updateDropdownOptions();
          currentVisibleCount = itemsPerPage; // Reset pagination
          updateJobPagination(); // Apply pagination
      }
  
  // On click "Show More"
      $('#load-more-btn').on('click', function () {
          currentVisibleCount += itemsPerPage;
          updateJobPagination();
      });
  */

  /*Last working filters*/
  /*    const $filters = {
          position: $('#filter-position'),
          department: $('#filter-department'),
          location: $('#filter-location')
      };
  
      const $clearButtons = {
          position: $('.clear-btn[data-target="filter-position"]'),
          department: $('.clear-btn[data-target="filter-department"]'),
          location: $('.clear-btn[data-target="filter-location"]')
      };
  
      const $jobItems = $('.job-item');
      const $loadMoreBtn = $('#load-more-btn');
  
      const itemsPerPage = 9;
      let currentVisibleCount = itemsPerPage;
  
  // Capitalize helper
      function capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
      }
  
  // Get unique options from currently matched (not visible!) jobs
      function getUniqueValues(attribute) {
          const values = new Set();
          $jobItems.each(function () {
              const $item = $(this);
              if ($item.data('match')) {
                  values.add($item.data(attribute));
              }
          });
          return Array.from(values).sort();
      }
  
  // Toggle clear button
      function toggleClearButton(key) {
          if ($filters[key].val()) {
              $clearButtons[key].show();
          } else {
              $clearButtons[key].hide();
          }
      }
  
  // Update dropdowns based on currently matching items
      function updateDropdownOptions() {
          ['position', 'department', 'location'].forEach(function (key) {
              const $select = $filters[key];
              const currentValue = $select.val();
              const options = getUniqueValues(key);
  
              const placeholderLabels = {
                  position: 'Jobtyp',
                  department: 'Abteilung',
                  location: 'Standort'
              };
  
              $select.empty();
              $select.append(`<option value="">${placeholderLabels[key]}</option>`);
              options.forEach(function (option) {
                  $select.append(`<option value="${option}">${option}</option>`);
              });
  
              if (options.includes(currentValue)) {
                  $select.val(currentValue);
              } else {
                  $select.val('');
              }
  
              toggleClearButton(key);
          });
      }
  
  // Filtering logic (marks match, but doesn't show)
      function filterJobItems() {
          const selectedFilters = {
              position: $filters.position.val(),
              department: $filters.department.val(),
              location: $filters.location.val()
          };
  
          $jobItems.each(function () {
              const $item = $(this);
              const isMatch = Object.keys(selectedFilters).every(function (key) {
                  return !selectedFilters[key] || $item.data(key) === selectedFilters[key];
              });
              $item.data('match', isMatch);
          });
  
          updateDropdownOptions();
          currentVisibleCount = itemsPerPage;
          updateJobPagination();
      }
  
  // Pagination logic
      function updateJobPagination() {
          const $matchingItems = $jobItems.filter(function () {
              return $(this).data('match');
          });
  
          $jobItems.hide(); // hide all
          $matchingItems.slice(0, currentVisibleCount).fadeIn(200); // show N matching
  
          if (currentVisibleCount < $matchingItems.length) {
              $loadMoreBtn.show();
          } else {
              $loadMoreBtn.hide();
          }
      }
  
  // Load more logic
      $loadMoreBtn.on('click', function () {
          const $matchingItems = $jobItems.filter(function () {
              return $(this).data('match');
          });
  
          currentVisibleCount = Math.min(currentVisibleCount + itemsPerPage, $matchingItems.length);
          updateJobPagination();
      });
  
  // Dropdown listeners
      Object.keys($filters).forEach(function (key) {
          $filters[key].on('change', function () {
              filterJobItems();
          });
      });
  
  // Clear buttons
      Object.keys($clearButtons).forEach(function (key) {
          $clearButtons[key].on('click', function () {
              $filters[key].val('');
              filterJobItems();
          });
      });
  
  // Initial dropdown population
      function initializeDropdowns() {
          ['position', 'department', 'location'].forEach(function (key) {
              const $select = $filters[key];
              const options = new Set();
              $jobItems.each(function () {
                  options.add($(this).data(key));
              });
  
  
              const placeholderLabels = {
                  position: 'Jobtyp',
                  department: 'Abteilung',
                  location: 'Standort'
              };
  
              $select.empty();
  
              $select.append(`<option value="">${placeholderLabels[key]}</option>`);
              Array.from(options).sort().forEach(function (option) {
                  $select.append(`<option value="${option}">${option}</option>`);
              });
  
              toggleClearButton(key);
          });
      }
  
  // On page load
      initializeDropdowns();
      $jobItems.data('match', true); // Assume all match on first load
      updateDropdownOptions();
      updateJobPagination();*/

  /*Updated dropdowns*/
  var $dropdowns = {
    position: $('.custom-dropdown[data-key="position"]'),
    department: $('.custom-dropdown[data-key="department"]'),
    location: $('.custom-dropdown[data-key="location"]')
  };
  var $clearButtons = {
    position: $('.clear-btn[data-target="filter-position"]'),
    department: $('.clear-btn[data-target="filter-department"]'),
    location: $('.clear-btn[data-target="filter-location"]')
  };
  var $jobItems = $('.job-item');
  var $loadMoreBtn = $('#load-more-btn');
  var itemsPerPage = 9;
  var currentVisibleCount = itemsPerPage;
  var selectedFilters = {
    position: '',
    department: '',
    location: ''
  };
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  function getUniqueValues(attribute) {
    var values = new Set();
    $jobItems.each(function () {
      var $item = $(this);
      if ($item.data('match')) {
        values.add($item.data(attribute));
      }
    });
    return Array.from(values).sort();
  }
  function toggleClearButton(key) {
    if (selectedFilters[key]) {
      $clearButtons[key].show();
    } else {
      $clearButtons[key].hide();
    }
  }
  function updateDropdownOptions() {
    ['position', 'department', 'location'].forEach(function (key) {
      var $dropdown = $dropdowns[key];
      var $list = $dropdown.find('.custom-dropdown-list');
      var $header = $dropdown.find('.custom-dropdown-header');
      var currentValue = selectedFilters[key];
      var options = getUniqueValues(key);
      var placeholderLabels = {
        position: 'Jobtyp',
        department: 'Abteilung',
        location: 'Standort'
      };
      $list.empty();
      //$list.append(`<li data-value="">${placeholderLabels[key]}</li>`);

      options.forEach(function (option) {
        $list.append("<li data-value=\"".concat(option, "\">").concat(option, "</li>"));
      });
      var currentLabel = currentValue || placeholderLabels[key];
      $header.text(currentLabel);
      toggleClearButton(key);
    });
  }
  function filterJobItems() {
    $jobItems.each(function () {
      var $item = $(this);
      var isMatch = Object.keys(selectedFilters).every(function (key) {
        return !selectedFilters[key] || $item.data(key) === selectedFilters[key];
      });
      $item.data('match', isMatch);
    });
    updateDropdownOptions();
    currentVisibleCount = itemsPerPage;
    updateJobPagination();
  }
  function updateJobPagination() {
    var $matchingItems = $jobItems.filter(function () {
      return $(this).data('match');
    });
    $jobItems.hide();
    $matchingItems.slice(0, currentVisibleCount).fadeIn(200);
    if (currentVisibleCount < $matchingItems.length) {
      $loadMoreBtn.show();
    } else {
      $loadMoreBtn.hide();
    }
  }

  // Handle dropdown selection
  $('.custom-dropdown').each(function () {
    var $dropdown = $(this);
    var key = $dropdown.data('key');
    $dropdown.on('click', '.custom-dropdown-header', function () {
      $('.custom-dropdown-list').not($(this).siblings('.custom-dropdown-list')).hide(); // close others
      $(this).siblings('.custom-dropdown-list').toggle(); // toggle current
    });

    $dropdown.on('click', '.custom-dropdown-list li', function () {
      var value = $(this).data('value');
      selectedFilters[key] = value;
      $dropdown.find('.custom-dropdown-header').text($(this).text());
      filterJobItems();
      $('.custom-dropdown-list').hide(); // close after selection
    });
  });

  // Clear buttons
  Object.keys($clearButtons).forEach(function (key) {
    $clearButtons[key].on('click', function () {
      selectedFilters[key] = '';
      filterJobItems();
    });
  });
  $loadMoreBtn.on('click', function () {
    var $matchingItems = $jobItems.filter(function () {
      return $(this).data('match');
    });
    currentVisibleCount = Math.min(currentVisibleCount + itemsPerPage, $matchingItems.length);
    updateJobPagination();
  });
  function initializeDropdowns() {
    ['position', 'department', 'location'].forEach(function (key) {
      var $dropdown = $dropdowns[key];
      var $list = $dropdown.find('.custom-dropdown-list');
      var placeholderLabels = {
        position: 'Jobtyp',
        department: 'Abteilung',
        location: 'Standort'
      };
      var options = new Set();
      $jobItems.each(function () {
        options.add($(this).data(key));
      });
      $list.empty();
      //$list.append(`<li data-value="">${placeholderLabels[key]}</li>`);
      Array.from(options).sort().forEach(function (option) {
        $list.append("<li data-value=\"".concat(option, "\">").concat(option, "</li>"));
      });
      $dropdown.find('.custom-dropdown-header').text(placeholderLabels[key]);
      toggleClearButton(key);
    });
  }

  // On page load
  initializeDropdowns();
  $jobItems.data('match', true);
  updateDropdownOptions();
  updateJobPagination();

  // Close dropdowns when clicking outside
  $(document).on('click', function (e) {
    if (!$(e.target).closest('.custom-dropdown').length) {
      $('.custom-dropdown-list').hide();
    }
  });
  AOS.init();
});